import React, { Component } from 'react'
import app from '../../feathers'
import { Prompt } from 'react-router-dom'
import { Textfield } from 'react-mdl'
import Button from '../../components/Button'

import UnitElementField from './UnitElementField'

const styles = {
  textfield: {
    width: '100%',
  },
}

class Create extends Component {
  state = {
    code: '',
    title: '',
    topic: '',
    industry: '',
    performanceCriteria: [],
    performanceEvidence: [],
    knowledgeEvidence: [],
    sections: [
      {
        name: 'Section 1',
        subsections: [
          {
            mapping: [],
            name: 'New Section',
          },
        ],
      },
    ],
  }
  onChange = ({ target }) => this.setState({ [target.name]: target.value })
  onSubmit = async e => {
    e.preventDefault()
    const unit = await app.service('units').create(this.state)
    this.props.onCreate(unit._id)
  }
  onKeyPress = e => {
    if (e.which === 13) {
      return e.preventDefault()
    }
  }
  onChangePerformanceCriteria = performanceCriteria =>
    this.setState({ performanceCriteria })
  onChangePerformanceEvidence = performanceEvidence =>
    this.setState({ performanceEvidence })
  onChangeKnowledgeEvidence = knowledgeEvidence =>
    this.setState({ knowledgeEvidence })
  render() {
    return (
      <form onSubmit={this.onSubmit} onKeyPress={this.onKeyPress}>
        <Textfield
          floatingLabel
          required
          style={styles.textfield}
          label="Unit Code"
          name="code"
          onChange={this.onChange}
          value={this.state.code}
        />
        <Textfield
          floatingLabel
          required
          style={styles.textfield}
          label="Unit Title"
          name="title"
          onChange={this.onChange}
          value={this.state.title}
        />
        <Textfield
          floatingLabel
          required
          style={styles.textfield}
          label="Unit Topic"
          name="topic"
          onChange={this.onChange}
          value={this.state.topic}
        />
        <Textfield
          floatingLabel
          required
          style={styles.textfield}
          label="Unit Industry"
          name="industry"
          onChange={this.onChange}
          value={this.state.industry}
        />
        <UnitElementField
          title="Performance Criteria"
          onChange={this.onChangePerformanceCriteria}
          elements={this.state.performanceCriteria}
        />
        <UnitElementField
          title="Performance Evidence"
          onChange={this.onChangePerformanceEvidence}
          elements={this.state.performanceEvidence}
        />
        <UnitElementField
          title="Knowledge Evidence"
          onChange={this.onChangeKnowledgeEvidence}
          elements={this.state.knowledgeEvidence}
        />
        <Button raised primary ripple type="submit">
          Create Unit
        </Button>
        <Prompt
          when={true}
          message="Are you sure you want to progress? There is no way to edit the Unit Elements past this page."
        />
      </form>
    )
  }
}

export default Create



// WEBPACK FOOTER //
// ./src/Units/CreateUnit/index.js